export default [
  // 数据导入-评价
  {
    path: '/digitalReview/evaluateDataImport',
    name: 'dataImport',
    component: () => import('@/pages/digitalReview/evaluateDataImport/index.vue'),
  },
  // 数据导入-评分
  {
    path: '/digitalReview/scoreDataImport',
    name: 'dataImport',
    component: () => import('@/pages/digitalReview/scoreDataImport/index.vue'),
  },
];
